<template>
  <div id="contacts-holder">
    <div class="container">

      <div class="row contacts-grid">
        <div class="col-lg-12">
          <p id="contacts-header">Fale conosco</p>
        </div>
        <div class="container">
          <div class="row">

            <div class="col-xl-8 col-lg-12 mb-2 mb-xl-0 ">
              <div class="card h-100">
                <div class="card-header p-0">
                  <iframe width="100%"
                          height="300"
                          frameborder="0"
                          scrolling="no"
                          marginheight="0"
                          marginwidth="0"
                          src="https://maps.google.com/maps?width=100%25&amp;height=300&amp;hl=pt-BR&amp;q=o%C3%A3o%20Janu%C3%A1rio%20Ayroso,%20156%20-%20Jaragu%C3%A1%20Esquerdo+(Bytecom)&amp;t=&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
                            <a href="https://www.gps.ie/sport-gps/">Bytecom</a>
                  </iframe>
                </div>
                <div class="card-body text-center align-items-center d-flex justify-content-center">
                  <div style="margin-bottom: 120px;">
                    <h3 class="fw-bold">Horários de Atendimento</h3>
                    <p class="card-text ">Segunda à Sexta-feira<br>
                      08:00 às 11:50 / 13:30 às 18:00<br>
                      <b>Endereço:</b> Rua João Januário Ayroso, 156<br>
                      Jaraguá Esquerdo - Jaraguá do Sul / SC<br>
                      <b>CEP:</b> 89253-100
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div class="col-xl-4 col-lg-12 ps-xl-0 contacts">
              <div class="row">

                <div class="col-xl-12 col-lg-6">
                  <div class="card mb-2">
                    <div class="card-header text-center">
                      <span>Suporte</span> <br>
                      <span class="contact-shift">Segunda à sexta</span>
                    </div>
                    <div class="card-body text-left position-relative">
                      <a class="contact-link" href="#"><i class="bi bi-whatsapp"></i> (47) 3370-0735</a> <br>
                      <a class="contact-link" href="#"><i class="bi bi-envelope"></i> suporte@bytecom.inf.br</a>
                      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi fit-icon bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12 col-lg-6">
                  <div class="card mb-2">
                    <div class="card-header text-center">
                      <span>Plantão Suporte</span> <br>
                      <span class="contact-shift">Finais de semana e feriados</span>
                    </div>
                    <div class="card-body text-left position-relative">
                      <a class="contact-link" href="#"><i class="bi bi-whatsapp"></i> (47) 3370-0735</a> <br>
                      <a class="contact-link" href="#"><i class="bi bi-envelope"></i> suporte@bytecom.inf.br</a>
                      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi fit-icon bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12 col-lg-6">
                  <div class="card mb-2">
                    <div class="card-header text-center">
                      <span>Financeiro</span> <br>
                      <span class="contact-shift">Segunda à sexta</span>
                    </div>
                    <div class="card-body text-left position-relative">
                      <a class="contact-link" href="#"><i class="bi bi-whatsapp"></i> (47) 3370-0735</a> <br>
                      <a class="contact-link" href="#"><i class="bi bi-envelope"></i> financeiro@bytecom.inf.br</a>
                      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi fit-icon bi-cash" viewBox="0 0 16 16">
                        <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                        <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12 col-lg-6">
                  <div class="card mb-2">
                    <div class="card-header text-center">
                      <span>Comercial</span> <br>
                      <span class="contact-shift">Segunda à segunda</span>
                    </div>
                    <div class="card-body text-left position-relative">
                      <a class="contact-link" href="#"><i class="bi bi-whatsapp"></i> (47) 3370-0735</a> <br>
                      <a class="contact-link" href="#"><i class="bi bi-envelope"></i> comercial@bytecom.inf.br</a>
                      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi fit-icon bi-headset" viewBox="0 0 16 16">
                        <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12 col-lg-6">
                  <div class="card">
                    <div class="card-header text-center">
                      <span>Trabalhe Conosco</span> <br>
                      <span class="contact-shift">Segunda à segunda</span>
                    </div>
                    <div class="card-body text-left position-relative">
                      <a class="contact-link" href="#"><i class="bi bi-whatsapp"></i> (47) 3370-0735</a> <br>
                      <a class="contact-link" href="#"><i class="bi bi-envelope"></i> weber@bytecom.inf.br</a> <br>
                      <a class="contact-link" href="#"><i class="bi bi-envelope"></i> guilherme@bytecom.inf.br</a>
                      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="currentColor" class="bi fit-icon bi-briefcase-fill" viewBox="0 0 16 16">
                        <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5z"/>
                        <path d="M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85v5.65z"/>
                      </svg>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>  
</template>

<script scoped>

export default {
  name: 'SectionContact',
  components: {
  }
}

</script>

<style scoped>

#contacts-header {
  font-size: 2.5rem;
  color: #fb7149;
  font-family: Montserrat Bold;
  font-style: italic;
  filter: drop-shadow(1px 1px rgba(122, 121, 121, 0.575));
  text-transform: uppercase;
}

.card {
  font-family: Montserrat Regular;
  border-radius: 15px 15px 15px 15px;
}

.card-header {
  line-height: 14px;
  background: linear-gradient(to right, #4258B1 0%, #EB5429 100%);
  color: #fff;

  border-radius: 15px 15px 0px 0px
}

.card-body {
  overflow: hidden;
}

.bi-whatsapp {
  font-size: 20px;
  color: green;  
}

.bi-envelope {
  font-size: 20px;
  color: black;
}

.fit-icon {
  position: absolute;
  top: 15px;
  right: -22px;
  rotate: -40deg;
  color: #b9babbcc;
}

#contacts-holder {
  padding: 70px 0;
  
  background: #ededed;
}

.card-text {
  color: rgb(88, 88, 88);
  font-size: 18px;
  line-height: 20px;
}

.contacts-grid {
  margin: 0 7%;
}

.contact-link {
  text-decoration: none;
  display: inline-inline;
}

@media (max-width: 576px) {
  .card-body h3 {
    font-size: 20px;
  }

  .card-body .contact-link {
    font-size: 12px;
  }

  .card-header span {
    font-size: 13px;
  }

  .card-text {
    font-size: 14px;
  }
}

</style>